/* ==========================================================================
   EDME İndirim Rozeti v1.0 — Ürün detay sayfası
   Fiyat alanındaki ([data-pdp-price]) üstü çizili ve güncel fiyattan indirim
   yüzdesini hesaplar, fiyatın yanına "%X İNDİRİM" rozeti ekler.
   Beden/varyant değişince edme-product.js fiyat alanını yeniden yazar;
   MutationObserver bunu yakalayıp rozeti yeniden hesaplar.
   Yüzde, ürün kartıyla aynı şekilde aşağı yuvarlanır.
   ========================================================================== */
(function () {
  function toCents(text) {
    if (!text) return 0;
    var s = String(text).replace(/[^0-9.,]/g, '');
    if (!s) return 0;
    if (s.indexOf(',') > -1) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      var parts = s.split('.');
      if (parts.length > 2 || (parts.length === 2 && parts[1].length === 3)) {
        s = s.replace(/\./g, '');
      }
    }
    return Math.round(parseFloat(s) * 100) || 0;
  }

  function apply(box) {
    var existing = box.querySelector('[data-pdp-discount]');
    var compareEl = box.querySelector('[data-pdp-price-compare]');
    var currentEl = box.querySelector('[data-pdp-price-current]');
    var pct = 0;

    if (compareEl && currentEl) {
      var compare = toCents(compareEl.textContent);
      var current = toCents(currentEl.textContent);
      if (compare > 0 && compare > current) {
        pct = Math.floor((compare - current) * 100 / compare);
      }
    }

    if (pct > 0) {
      var label = '%' + pct + ' İNDİRİM';
      if (existing) {
        if (existing.textContent !== label) existing.textContent = label;
        return;
      }
      var badge = document.createElement('span');
      badge.className = 'edme-pdp__discount-badge';
      badge.setAttribute('data-pdp-discount', '');
      badge.textContent = label;
      box.appendChild(badge);
    } else if (existing) {
      existing.parentNode.removeChild(existing);
    }
  }

  function init() {
    var boxes = document.querySelectorAll('[data-pdp-price]');
    Array.prototype.forEach.call(boxes, function (box) {
      apply(box);
      new MutationObserver(function () { apply(box); }).observe(box, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
